import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { BrandedLoginComponent } from './branded-login.component';
import { LoginFormModule } from '../login-form/login-form.module';
import { AuthVerifyEmailModule } from '../../shared/auth-verify-email/auth-verify-email.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthLogoModule } from '../../shared/auth-logo/auth-logo.module';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Routing
        RouterModule.forChild([
            {
                path: '',
                component: BrandedLoginComponent,
            },
        ]),
        LoginFormModule,
        AuthVerifyEmailModule,
        MatProgressSpinnerModule,
        AuthLogoModule,
    ],
    declarations: [BrandedLoginComponent],
    providers: [],
})
export class BrandedLoginModule
{
}
